import { useLang } from '@/i18n';
import EfCardsAppB from '@elem/ui/ef-cards-app-b';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import { useState } from 'react';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.ListB');
    const [listA, setListA] = useState([
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737684240185/ListB1-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1737684239514/ListB1-h5.jpg',
            title: t('a_title'),
            desc: t('a_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737684239990/ListB3-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1737684240350/ListB3-h5.jpg',
            title: t('b_title'),
            desc: t('b_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1737684239807/ListB2-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1737684239645/ListB2-h5.jpg',
            title: t('c_title'),
            desc: t('c_desc'),
        },
    ]);

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} />
            <EfCardsAppB type="noneOver" list={listA} />
        </div>
    );
}
